import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import thankYou from '../../assets/gifs/loggedOutMan.gif';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { useNavigate } from 'react-router-dom';
import TriangleBg from '../../assets/images/TriangleBg.svg';
import { makeStyles } from '@mui/styles';
import { ImageListItem } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
    },
    backdrop: {
        background: 'linear-gradient(180deg, #6BF98D 0%, #16C7FF 100%)',
        height: '45vh',
    },
    pageContents: {
        backgroundColor: 'white',
        width: '80%',
        position: 'absolute',
        top: '20%',
        left: '50%',
        right: '50%',
        transform: 'translate(-50%, 0)',
        borderRadius: 4,
        padding: 16,
        textAlign: 'center',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
        marginBottom: 40,
    },
}));

const ThankYou = () => {
    const classes = useStyles();
    const contentsRef = useRef(null);
    const navigate = useNavigate();

    const [containerHeight, setContainerHeight] = useState(500);

    useEffect(() => {
        if (null !== contentsRef.current) {
            let offset = contentsRef.current?.offsetTop;
            let height = contentsRef.current?.clientHeight;
            setContainerHeight(offset + height + 50);
        }
    }, [contentsRef.current]);

    return (
        <Box className={classes.container} height={containerHeight}>
            <Box className={classes.backdrop}>
                <Box sx={{ background: `url(${TriangleBg})`, height: '100%' }}></Box>
            </Box>
            <Box className={classes.pageContents} ref={contentsRef}>
                <ImageListItem sx={{ width: 250, height: 250, ml: -8 ,display:'inline-block'}}>
                    <img alt='Logged out' src={thankYou}></img>
                </ImageListItem>
                <Typography variant='h4'>See you again !</Typography>
                <Typography sx={{ my: 2 }} variant='body1'>
                    You have successfully logged out.
                </Typography>
                <Button sx={{ my: 2 }} variant='contained' onClick={() => navigate('/login')}>
                    Login again
                </Button>
            </Box>
        </Box>
    );
};

export default ThankYou;
